import { Injectable } from '@angular/core'
import {
  BasePageMetaResolver,
  BreadcrumbMeta,
  CmsService,
  ContentPageMetaResolver,
  OccEndpointsService,
  PageType,
  TranslationService,
  WindowRef
} from '@spartacus/core'
import { combineLatest, Observable, of } from 'rxjs'
import { distinctUntilChanged, switchMap } from 'rxjs/operators'
import { EbOrderDetailsService } from '../../order/services/facades/eb-order-details.service'
import { EBOGPMetaData, EbPage } from '../interfaces/eb-page.interface'

@Injectable({
  providedIn: 'root'
})
export class EbContentPageMetaResolver extends ContentPageMetaResolver {
  constructor(
    protected basePageMetaResolver: BasePageMetaResolver,
    protected cms: CmsService,
    protected orderDetailsService: EbOrderDetailsService,
    protected translationService: TranslationService,
    protected occEndpoints: OccEndpointsService,
    protected winRef: WindowRef
  ) {
    super(basePageMetaResolver)
    this.pageType = PageType.CONTENT_PAGE
  }

  protected page$ = this.cms.getCurrentPage() as Observable<EbPage>

  resolveTitle(): Observable<string | undefined> {
    return this.page$.pipe(
      switchMap(page => {
        const metaTitle = page?.metaTitle ?? ''
        const title = [page?.title]

        if (metaTitle) {
          title.push(metaTitle)
        }

        return of(title.join(' | '))
      })
    )
  }

  resolveOGPMetaData(): Observable<EBOGPMetaData> {
    const baseUrlWithoutPrefixAndBaseSite = this.occEndpoints.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false
    })

    return this.page$.pipe(
      switchMap(page => {
        const imageUrl = page.logo?.includes(baseUrlWithoutPrefixAndBaseSite)
          ? page.logo
          : baseUrlWithoutPrefixAndBaseSite + page.logo
        return of({
          title: page.title || page.metaTitle,
          description: page.metaDescription,
          type: 'website',
          url: this.winRef.location.href,
          image: imageUrl || ''
        })
      })
    )
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return combineLatest([
      this.page$,
      this.orderDetailsService.orderCode$,
      this.translationService.translate('orderHistory.orderHistory')
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([page, orderId, orderHistoryTitle]) => {
        const crumbs = [] as BreadcrumbMeta[]
        if (page?.pageId === 'orderDetail') {
          const items = [
            {
              label: orderHistoryTitle,
              link: '/my-account/orders'
            },
            {
              label: orderId,
              link: ''
            }
          ]
          crumbs.push(...items)
          return of(crumbs)
        }
        crumbs.push({
          label: page?.title,
          link: page?.label
        })
        return of(crumbs)
      })
    )
  }
}
